{
  "version": "v4.0.0",
  "name": "MathTest",
  "bytecode": "0002174053010002020109d38c844efd16000d1340703b2c16012d0201000103014020d36ae1998016000f334c191600170116000e2d0d2a170216021601314c0b16021701160016022d16022a0e2d17024a311601020d02",
  "codeHash": "732c8ff5b38eadaa96074453394619cb78ddf7371ff94ce7fb3dbe5fe332655c",
  "fieldsSig": {
    "names": [],
    "types": [],
    "isMutable": []
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "uqdiv",
      "paramNames": [
        "a",
        "b"
      ],
      "paramTypes": [
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "sqrt",
      "paramNames": [
        "y"
      ],
      "paramTypes": [
        "U256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "U256"
      ]
    }
  ],
  "constants": [],
  "enums": []
}